import React from "react";
import { SeoHeaderProps } from "../../components/SeoHeader";
import { ServiceCataloguePageWrapper } from "../../components/ServiceCataloguePageWrapper";
import { Paragraph, ParagraphProps } from "../../components/Paragraph";
import { GenericListProps } from "../../types/GenericListType";
import { GreyCard, GreyCardProps } from "../../components/GreyCard";
import { FaqAccordionGroupProps } from "../../components/FaqAccordionGroup/FaqAccordionGroup";
import { Links, LinksProps } from "../../components/Links";
import { List } from "../../components/List";
import { GroupedComponents } from "../../components/GroupedComponents";

export interface TreeRelatedFaultsPageProps {
  seo?: SeoHeaderProps;
  pageTitle: string;
  paragraphs?: ParagraphProps[];
  lists?: GenericListProps[];
  wantToReport?: GreyCardProps;
  linksList?: LinksProps[];
  faqs?: FaqAccordionGroupProps;
}

export const TreeRelatedFaultsPage: React.FC<TreeRelatedFaultsPageProps> = ({
  seo,
  pageTitle,
  paragraphs,
  lists,
  wantToReport,
  linksList,
  faqs,
}) => {
  return (
    <ServiceCataloguePageWrapper seo={seo} title={pageTitle} faqs={faqs}>
      <GroupedComponents>
        {paragraphs && paragraphs[0] && <Paragraph {...paragraphs[0]} />}
        {lists && lists[0] && <List {...lists[0]} />}
      </GroupedComponents>
      {wantToReport && <GreyCard {...wantToReport} />}
      {linksList && linksList[0] && <Links {...linksList[0]} />}
    </ServiceCataloguePageWrapper>
  );
};
